import { Action } from '@ngrx/store';
import * as _ from 'lodash';
import { MultiInvoice } from './state-models/multi-invoice';

export enum MultiInvoiceActions {
    LoadMultiInvoicePageAction='[ MultiInvoice ] Load multi invoice',  
    ChangeMultiInvoicePageAction='[ MultiInvoice ] Change multi invoice',
    ChangeMultiInvoiceSortExpressionAction='[ MultiInvoice ] Change Sort Expression',
    ChangeMultiInvoiceFilterExpressionAction='[ MultiInvoice ] Change Filter Expression',
    ChangeMultiInvoiceTotalCountAction='[ MultiInvoice ] Total Count Expression'
}

export class ChangeMultiInvoiceSortExpressionAction implements Action {
    readonly type = MultiInvoiceActions.ChangeMultiInvoiceSortExpressionAction;
    constructor(public payload: string) { }
}

export class ChangeMultiInvoiceFilterExpressionAction implements Action {
    readonly type = MultiInvoiceActions.ChangeMultiInvoiceFilterExpressionAction;
    constructor(public payload: string) { }
}

export class ChangeMultiInvoiceTotalCountAction implements Action {
    readonly type = MultiInvoiceActions.ChangeMultiInvoiceTotalCountAction;
    payload: { totalCount: number};
    constructor(totalCount: number) {
        this.payload = { totalCount};
    }
}

export class ChangeMultiInvoicePageAction implements Action {
    readonly type = MultiInvoiceActions.ChangeMultiInvoicePageAction;
    constructor(public payload: number) { }
}

export class LoadMultiInvoicePageAction implements Action {
    readonly type = MultiInvoiceActions.LoadMultiInvoicePageAction;
    constructor(public payload: MultiInvoice[]) { }
}


export type MultiInvoiceAction =
    | LoadMultiInvoicePageAction   
    | ChangeMultiInvoiceSortExpressionAction
    | ChangeMultiInvoiceFilterExpressionAction
    | ChangeMultiInvoiceTotalCountAction
    | ChangeMultiInvoicePageAction
    ;
